<!-- 批量选型-室内机 -->
<template>
  <div id="ProductList" class="page product-list">
    <div class="content-box">
      <indoor-unit-search ref="indoorUnitSearch" />
      <el-table
        :data="tableData"
        v-if="tableData.length"
        :row-style="{ height: '40px' }"
        :cell-style="cellStyle"
        :height="tableHeight"
        v-loading="isLoading"
      >
        <el-table-column prop="roomCode" label="房间编号">
          <template v-slot="{ row }">
            {{ row.roomCode || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="roomName" label="房间名称">
          <template v-slot="{ row }">
            {{ row.roomName || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="roomArea" label="房间面积 (㎡)">
          <template v-slot="{ row }">
            {{ row.roomArea || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="coolingLoad" label="冷负荷(KW)">
          <template v-slot="{ row }">
            {{ row.coolingLoad || "- -" }}
          </template>
        </el-table-column>
        <el-table-column prop="heatLoad" label="热负荷(KW)">
          <template v-slot="{ row }">
            {{ row.heatLoad || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="calEquipmentNumber"
          label="计算数量"
          width="80px"
        >
          <template v-slot="{ row }">
            {{ row.calEquipmentNumber || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          label="指定数量"
          width="140px"
          align="center"
          prop="equipmentNumber"
        >
          <template slot-scope="scope">
            <el-input-number
              width="110px"
              :min="1"
              :precision="0"
              @change="numberChange(scope.row)"
              v-model="scope.row.equipmentNumber"
              placeholder="不指定"
            />
          </template>
        </el-table-column>
        <el-table-column prop="model" label="设备型号" width="200px">
          <template v-slot="{ row }">
            {{ row.model || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cold"
          :render-header="renderHeader"
          label="制冷量(KW)"
        >
          <template v-slot="{ row }">
            {{ (row.selectionParameter && row.selectionParameter[0].value) || "- -" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="heat"
          :render-header="renderHeader"
          label="制热量(KW)"
        >
          <template v-slot="{ row }">
            {{ (row.selectionParameter && row.selectionParameter[1].value) || "- -"  }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="144px">
          <template slot-scope="scope">
            <el-button
              @click="chooseDetail(scope.row, 'detail')"
              style="margin-right: 16px"
              type="text"
              size="small"
              :disabled="buttonIsShow || !scope.row.productIds"
            >查看详情</el-button>
            <el-button
              @click="chooseOthers(scope.row, 'others', scope.$index)"
              type="text"
              size="small"
              :disabled="buttonIsShow"
            >重新选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <empty-content text="暂无房间信息" v-else />
      <!-- 抽屉 -->
      <el-drawer
        close-on-click-modal
        :append-to-body="true"
        :modal="true"
        @open="handleOpen"
        :before-close="handleClose"
        :destroy-on-close="true"
        :direction="direction"
        :visible.sync="drawer"
        :size="drawerWidth"
        :custom-class="buttonType === 'detail'?'product-detail-drawer':''"
      >
        <template v-if="buttonType !== 'detail'" #title>
          <span>{{ currentRow.roomName }}</span>
        </template>
        <div>
          <fan-coil-detail v-if="this.buttonType === 'detail'" :productIds="productIds" />
          <indoor-unit-others
            v-else
            ref="IndoorUnitOthers"
            :productRow="productRow"
            :currentRow="currentRow"
            :room="currentRoomInfo"
            :row-search="currentRowSearchData"
            @selectRow="getRow"
          />
        </div>
      </el-drawer>
      <!-- 一键选型 -->
      <el-row>
        <el-button class="lectotype" @click="chooseMsg()">一键选型</el-button>
        <el-button
          class="confirm"
          @click="confirmAction()"
          :class="buttonIsShow ? 'active' : 'noActive'"
          :disabled="buttonIsShow"
        >确认方案</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import FanCoilDetail from './FanCoilDetail.vue'
import IndoorUnitOthers from './IndoorUnitOthers.vue'
import IndoorUnitSearch from './components/batchSelection/IndoorUnitSearch.vue'
import {
  GetEquipmentBatchSelectionArguments,
  SetEquipmentBatchSelectionResults,
  GetGdcAccessToken,
} from '@/core/gcsUtils'
import EmptyContent from '@/components/business/EmptyContent'

export default {
  name: 'ProductList',
  components: {
    FanCoilDetail,
    IndoorUnitOthers,
    IndoorUnitSearch,
    EmptyContent,
  },
  data() {
    return {
      isFirstChoose: true,
      indoorUnitSearch: {},
      // 点击重新选择的房间的信息
      currentRoomInfo: {},
      buttonIsShow: true,
      isLoading: false,
      buttonType: '',
      drawer: false,
      innerDrawer: false,
      direction: 'ltr',
      drawerWidth: '1120px',
      pageSize: 50,
      tableData: [],
      tableDataCopyChoose: [],
      productIds: '', // 产品ID
      productRow: [],
      currentRow: [],
      currentRowSearchData: {},
      currentValue: [],
      currentId: '', // 当前选择行ID
      selectVal: {},
      detailId: '',
      inputCondition: [],
      isChangeRow: false,
      currentIndex: '',
      tableDataReplace: [],
      confirmProductIds: [],
      tableHeight: null,
      resultData: [],
      // 品类编码
      gjwCategoryCode: 'C000005',
      // 品类名称
      gjwCategoryName: '多联机',
      g_c_default_condition: true,
      g_c_selection_best_result: [],
      g_c_selection_alternative_result: [],
      // 结构形式传参
      paramsForProperties: {
        gjwCategoryCode: this.gjwCategoryCode,
        productProperties: [
          {
            code: 'P000092',
            parameterType: 'Enums',
            queryType: 'EQUAL',
            value: 'V000067',
          },
        ],
        brandCode: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      brands: 'list/brands',
    }),
  },
  created() {
    // 获取机电数据
    this.getEquipmentBatchSelectionArguments()
    // 获取品牌
    this.loadBrands({
      gjwCategoryCode: this.gjwCategoryCode,
      productProperties: [
        {
          code: 'P000092',
          parameterType: 'Enums',
          queryType: 'EQUAL',
          value: 'V000067',
        },
      ],
    })
    this.loadAggProperties(this.paramsForProperties)
  },

  mounted() {
    // 访问批量选型埋点
    this.$tracks({
      event: 'visitBachSelection',
      params: {
        g_c_class_code: this.gjwCategoryCode,
        g_c_class_name: this.gjwCategoryName,
      },
    })
    // 窗口重置时候，重新获取高度
    this.tableHeight = document.body.clientHeight - 152
    window.onresize = () => {
      return (() => {
        this.tableHeight =
          document.body.clientHeight > 750
            ? document.body.clientHeight - 196
            : document.body.clientHeight - 152
      })()
    }
  },

  methods: {
    ...mapMutations({
      setProductId: 'productDetail/setProductId',
      setUserToken: 'user/setUserToken',
    }),

    ...mapActions({
      // 获取品牌
      loadBrands: 'list/loadBrands',
      // 获取筛选
      loadAggProperties: 'fanList/loadAggProperties',
      // 获取产品详情
      loadProperties: 'productDetail/loadProperties',
      loadDetail: 'productDetail/loadDetail',
      loadRelatedComponents: 'productDetail/loadRelatedComponents',
      loadRelatedBlocks: 'productDetail/loadRelatedBlocks',
    }),

    // 获取机电数据
    async getEquipmentBatchSelectionArguments() {
      const projectInfoStr = await GetEquipmentBatchSelectionArguments()
      const { data: gToken } = await GetGdcAccessToken()
      this.setUserToken(gToken || null)
      // 获取机电传参
      this.inputCondition = projectInfoStr.data
      // this.inputCondition = [
      //   {
      //     coolingLoad: 50,
      //     heatLoad: 2,
      //     roomArea: 140,
      //     roomCode: '10one',
      //     roomId: '1',
      //     roomName: '1号房'
      //   },
      //   {
      //     coolingLoad: 100,
      //     heatLoad: 200,
      //     roomArea: 100,
      //     roomCode: '00one2',
      //     roomId: '2',
      //     roomName: '2号房'
      //   },
      //   {
      //     coolingLoad: 150,
      //     heatLoad: 250,
      //     roomArea: 1500,
      //     roomCode: '00one3',
      //     roomId: '3',
      //     roomName: '3号房'
      //   },
      //   {
      //     coolingLoad: 200,
      //     heatLoad: 200,
      //     roomArea: 140,
      //     roomCode: '00one4',
      //     roomId: '4',
      //     roomName: '4号房'
      //   },
      //   {
      //     coolingLoad: 90,
      //     heatLoad: 90,
      //     roomArea: 140,
      //     roomCode: '00one5',
      //     roomId: '51',
      //     roomName: '5号房'
      //   }
      // ]
      this.tableData = JSON.parse(JSON.stringify(this.inputCondition))
      // console.log("this.tableData:", this.tableData);
    },

    // 列表头换行
    renderHeader(h, { column, $index }) {
      const columnArr = column.label.split('||') // 此处换行标志
      if (columnArr.length >= 2) {
        const divArr = []
        columnArr.map((item) => {
          divArr.push(h('div', { style: 'text-align: center ' }, item))
        })
        return h('div', {}, divArr)
      }
      return h('div', {}, column.label)
    },

    // 设置行样式
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (row.model === '未找到合适型号' && columnIndex > 6) {
        cellStyle = 'color: #E9AB39;'
      }
      return cellStyle
    },

    // 一键选型
    chooseMsg() {
      if (this.isFirstChoose) {
        this.isFirstChoose = false
        this.confirmChooseMsg()
      } else {
        this.$confirm('再次选型将覆盖已有数据，是否确认再次批量选型？', '确认提示', {
          type: 'warning',
          customClass: 'customClass',
        }).then(() => {
          this.confirmChooseMsg()
        }).catch(() => {})
      }
    },
    confirmChooseMsg() {
      this.isLoading = true
      this.buttonIsShow = false
      const data = this.$refs.indoorUnitSearch.getSearchData()
      this.indoorUnitSearch = data.searchData
      this.g_c_default_condition = data.g_c_default_condition
      const productProperties = data.productProperties
      const validationProperties = data.validProperties
      const nonValidationProperties = data.nonValidProperties

      const paramsForMulti_room = {
        topSize: this.pageSize,
        brandCode: this.indoorUnitSearch.brandCode,
        inputCondition: this.inputCondition,
        productProperties: productProperties,
        singleUnitResponsibilityArea: this.indoorUnitSearch.singleUnitResponsibilityArea,
        nonValidationProperties: nonValidationProperties,
        validationProperties: validationProperties,
      }
      this.$api.products.getMulti_room(this.gjwCategoryCode, paramsForMulti_room).then((res) => {
        const that = this
        res = res || []
        that.resultData = JSON.parse(JSON.stringify(res))
        that.isLoading = false
        that.tableDataReplace = res
        // 获取一键选型中返回的备选结果id列表
        that.g_c_selection_best_result = []
        that.g_c_selection_alternative_result = []
        res.forEach((v) => {
          if (v.id) {
            that.g_c_selection_best_result.push({
              roomId: v.roomId,
              productId: v.id,
            })
            that.g_c_selection_alternative_result.push({
              roomId: v.roomId,
              productId: v.productIds,
            })
          }
        })
        // 属性筛选：一键筛选参数（全局筛选条件）只包含筛选条件的内容，不包含机电穿过的
        delete paramsForMulti_room.inputCondition
        // 批量选型埋点
        this.$tracks({
          event: 'batchSelection',
          params: {
            g_c_class_code: this.gjwCategoryCode,
            g_c_class_name: this.gjwCategoryName,
            g_c_brand_code: that.brandCode,
            g_c_brand_name: that.brandName,
            // 选型初始条件： 机电传入数据
            g_c_selection_initial_condition: that.inputCondition,
            // 属性筛选：一键筛选参数（全局筛选条件）
            g_c_property: paramsForMulti_room,
            // 是否缺省条件：一键选型中增加全局筛选则为false
            g_c_default_condition: this.g_c_default_condition,
            // 最优选项结果：列表数据
            g_c_selection_best_result: that.g_c_selection_best_result,
            // 备选结果：一键选型中返回的备选结果id列表
            g_c_selection_alternative_result:
                that.g_c_selection_alternative_result,
            // 批量个数：房间的个数
            g_c_batch_numbers: that.inputCondition.length,
            // 批量成功个数：有最优选的房间的个数
            g_c_batch_success_numbers: that.g_c_selection_best_result.length,
          },
        })
        const tableCopy = JSON.parse(JSON.stringify(that.tableData))
        tableCopy.forEach((v, index) => {
          that.tableDataReplace.forEach((j, index) => {
            if (v.roomId === j.roomId) {
              tableCopy[index] = {
                ...tableCopy[index],
                ...that.tableDataReplace[index],
              }
            }
          })
        })
        tableCopy.forEach((v, index) => {
          if (!v.model) {
            v.model = '未找到合适型号'
          }
        })
        that.tableData = tableCopy
        that.tableData.forEach((v) => {
          // 一键选型时，将批量查询条件内置到每个房间
          v.searchData = { ...this.indoorUnitSearch, validChecked: [...this.indoorUnitSearch.validChecked] }
          // 优先展示指定设备台数
          if (!v.equipmentNumber) {
            v.equipmentNumber = undefined
          } else {
            v.calEquipmentNumber = '- -'
          }
        })
      }).catch(() => {
        this.isLoading = false
        this.$msgbox(
          '存在过大或过小的输入值，请检查是否符合实际情况并重新输入。',
          '提示',
          {
            confirmButtonText: '确定',
            callback: (action) => {
              this.$message({
                type: 'info',
                message: `action: ${action}`,
              })
            },
          }
        )
      })
    },

    // 确认方案
    confirmAction() {
      this.tableData.forEach((v) => {
        v.id && this.confirmProductIds.push(v.id)
      })
      const parameter_Undoor_values = {
        paramsObj: { productIds: this.confirmProductIds },
        parameter_filter: 'GMEP_PARAMETER',
      }

      this.$api.products.parameter_Undoor_values(parameter_Undoor_values).then((res) => {
        const data = res
        // console.log("res:", res);
        const that = this
        that.result = []
        that.tableData.forEach((v) => {
          if (!v.id) {
            that.result.push({
              roomArea: v.roomArea,
              roomCode: v.roomCode,
              roomId: v.roomId,
              roomName: v.roomName,
              equipmentNumber: v.equipmentNumber || v.calEquipmentNumber,
            })
          }
          data.forEach((j) => {
            if (v.id && v.id === j.id) {
              that.result.push({
                roomArea: v.roomArea,
                roomCode: v.roomCode,
                roomId: v.roomId,
                roomName: v.roomName,
                equipmentNumber: v.equipmentNumber || v.calEquipmentNumber,
                productId: v.id,
                productModel: v.model,
                productName: v.name,
                parameters: j.parameters,
              })
            }
          })
        })
        const g_c_confirm_best_result = []
        that.result.forEach((v) => {
          if (v.productId) {
            g_c_confirm_best_result.push({
              roomId: v.roomId,
              productId: v.productId,
            })
          }
        })
        // 确认批量选型结果埋点
        this.$tracks({
          event: 'confirmBatchSelection',
          params: {
            g_c_class_code: this.gjwCategoryCode,
            g_c_class_name: this.gjwCategoryName,
            // 最优选项结果：列表数据
            g_c_selection_best_result: g_c_confirm_best_result,
            // 批量个数：房间的个数
            g_c_batch_numbers: that.inputCondition.length,
            // 批量成功个数：有最优选的房间的个数
            g_c_batch_success_numbers: that.g_c_selection_best_result.length,
          },
        })
        // console.log('that.result:', that.result)
        SetEquipmentBatchSelectionResults(that.result)
      })
    },

    // 抽屉弹出事件
    handleOpen() {
      if (this.buttonType === 'detail') {
        this.setProductId(this.productIds)
        this.loadProperties()
        this.loadDetail()
        this.loadRelatedComponents()
        this.loadRelatedBlocks()
      }
    },

    // 抽屉事件
    handleClose(done) {
      if (this.buttonType !== 'detail' && this.isChangeRow) {
        this.$confirm(
          '是否确认选择 ' + this.selectVal.model + ' ?',
          '选择确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '放弃修改',
            type: 'warning',
            customClass: 'customClass',
          }
        )
          .then(() => {
            this.$message({
              message: '选型结果已更新',
              type: 'success',
            })
            this.changeRow()
            done()
          })
          .catch(() => {
            this.isChangeRow = false
            done()
          })
      } else {
        done()
      }
    },

    // 获取行数据
    getRow({ row, index }) {
      this.detailId = row.id
      this.isChangeRow = true
      this.selectVal = row
      this.selectIndex = index
    },

    // 修改行数据
    changeRow() {
      const index = this.currentIndex
      this.tableData[index].id = this.selectVal.id
      this.tableData[index].index = this.selectVal.index
      this.tableData[index].imageUrl = this.selectVal.imageUrl
      this.tableData[index].model = this.selectVal.model
      this.tableData[index].name = this.selectVal.name
      this.tableData[index].productSeriesId = this.selectVal.productSeriesId
      this.tableData[index].productSeriesName = this.selectVal.productSeriesName
      this.tableData[index].selectionParameter = this.selectVal.parameters
      this.tableData[index].searchData = this.selectVal.searchData
      this.tableData[index].productIds = this.selectVal.productIds
    },

    // 查看详情
    async chooseDetail(row, type) {
      this.buttonType = type
      this.currentRow = row
      // 获取产品ID
      this.productIds = row.id
      this.drawer = true
      const projectInfo = await this.getProjectInfo()
      // 查看详情埋点
      this.$tracks({
        event: 'visitProductDetail',
        params: {
          g_c_class_code: this.gjwCategoryCode,
          g_c_class_name: this.gjwCategoryName,
          g_c_product_id: row.id,
          g_c_product_name: row.name,
          g_c_source: 'batchSelection',
          g_c_project_id: projectInfo.id,
          g_c_project_file_path: projectInfo.path,
          g_c_project_file_name: projectInfo.name
        },
      })
    },

    // 重新选择
    chooseOthers(row, type, index) {
      // console.log(row, '===')
      this.isChangeRow = false
      this.currentRow = row
      this.currentRowSearchData = { ...row.searchData }
      this.currentRoomInfo = this.inputCondition.find((it) => it.roomId === row.roomId) || {}
      this.productRow = JSON.parse(JSON.stringify(row.productIds))
      this.currentId = row.id
      // 记录当前选取行
      this.currentIndex = index
      this.buttonType = type
      this.drawer = true
    },

    // 计算台数改变事件
    numberChange(v) {
      const changeRow = v
      this.inputCondition.forEach((v) => {
        if (v.roomId === changeRow.roomId) {
          v.equipmentNumber = changeRow.equipmentNumber
        }
      })
    },
  },
}
</script>

<style>
.customClass .el-icon-warning {
  color: #409eff !important;
}
</style>

<style lang="less" scoped>
.product-list {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  font-size: 12px;
}
.search-block {
  position: relative;
  display: flex;
  padding: 8px 0;
  line-height: 24px;
  .label {
    height: 24px;
    line-height: 24px;
  }
  .switch {
    margin: 4px 16px 4px 0;
  }
}
.select-input {
  width: 108px;
}
.keyword-label {
  margin: 0 6px 0 16px;
}
.search-label {
  margin-right: 8px;
}
.narrow {
  width: 73px;
}
.line_left {
  height: 16px;
  padding-right: 8px;
  border-left: 1px #ccc solid;
}
/deep/.el-input__inner {
  height: 24px !important;
  line-height: 24px !important;
}
/deep/.content-box .has-gutter tr {
  height: 50px !important;
}
/deep/.content-box .el-table__header-wrapper {
  height: 50px !important;
}
/deep/.el-table__row {
  height: 40px !important;
}
/deep/.el-table th {
  padding: 0 !important;
}
/deep/.el-table td {
  padding: 0 !important;
}
/deep/.el-input-number--mini {
  width: 116px;
  line-height: 22px;
}
/deep/.el-button {
  margin-left: 0 !important;
}
/deep/.el-button--text {
  color: #4897f5;
}
/deep/.focus-message {
  color: red !important;
  background: blue !important;
}
/deep/.el-message--warning {
  background: blue !important;
}

.el-row {
  text-align: right;
}
.el-row .el-button {
  color: #fff;
  margin: 8px;
  width: 120px;
  height: 32px;
  border-radius: 2px;
}
.lectotype {
  color: #fff;
  background: #409eff;
}
.lectotype:focus {
  background: #409eff;
}
.confirm {
  color: #2dafcd !important;
}
.lectotype:hover {
  background: #409eff;
}
.active {
  color: #ccc !important;
  border-color: #ccc !important;
}
.noActive {
  color: #409eff !important;
  border-color: #409eff !important;
}
</style>
